module.exports = __webpack_public_path__ + "img/399d4c5.png";